import { Box, Flex, Text } from '@everlywell/ui-kit';
import BulletPointWithIcon from 'components/PageSections/components/BulletPointWithIcon';
import React from 'react';

// Types ----------

type ListItem = {
  text: string;
  icon?: string | null;
  iconColor?: string | null;
};

export type BulletPointsProps = {
  title: string;
  items: ListItem[];
};

// BulletList ------

const BulletPoints: React.FC<BulletPointsProps> = (props) => {
  const { items: bulletPointsItems, title: bulletPointsTitle } = props;

  const bullets = bulletPointsItems?.map((bullet, index) => (
    <BulletPointWithIcon
      key={index}
      iconName="Check"
      iconColor="tints.white"
      text={bullet.text}
      hasRoundIconBackground={true}
      iconBackgroundColor="violet.lighter"
      backgroundSize={16}
      iconFontSize={12}
    />
  ));

  return (
    <Box>
      {bulletPointsTitle ? (
        <Text size="lg" color="tints.uiGrey" marginBottom="4">
          {bulletPointsTitle}
        </Text>
      ) : null}

      <Flex gap={2} flexDirection="column">
        {bullets}
      </Flex>
    </Box>
  );
};

// Export ---------

export default React.memo(BulletPoints);
